import { jsx as _jsx } from "react/jsx-runtime";
import { Combobox } from "@opala-ds/react";
import { useGetSchoolByCity } from "../../queries/jepis";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
export default function EducationalInstitutionSchoolNameSelect(_a) {
    var defaultValue = _a.defaultValue;
    var _b = useFormContext(), control = _b.control, setValue = _b.setValue, watch = _b.watch, errors = _b.formState.errors;
    var selectedCity = watch("municipio");
    var _c = useGetSchoolByCity(selectedCity), schoolNames = _c.data, isFetching = _c.isFetching;
    var message = function (errorMessage) {
        if (errorMessage)
            return errorMessage;
        if (!selectedCity)
            return "Selecione uma cidade primeiro";
        return "";
    };
    useEffect(function () {
        if (!defaultValue)
            return;
        setValue("nome", defaultValue);
    }, [defaultValue, setValue]);
    return (_jsx(Controller, { control: control, name: "nome", render: function (_a) {
            var _b, _c, _d;
            var field = _a.field;
            return (_jsx(Combobox, { label: "Nome da escola (nome fantasia)", placeholder: (field === null || field === void 0 ? void 0 : field.value) ? field === null || field === void 0 ? void 0 : field.value : "Selecione", containerClassName: "".concat(field && "[&>button>div]:text-[#262626]", " ").concat(!(field === null || field === void 0 ? void 0 : field.value) && "cursor-not-allowed"), defaultValue: defaultValue, value: (_b = field === null || field === void 0 ? void 0 : field.value) === null || _b === void 0 ? void 0 : _b.toString(), onSelectValue: function (value) {
                    field.onChange(value);
                    var selectedSchool = schoolNames === null || schoolNames === void 0 ? void 0 : schoolNames.find(function (school) { return value === school.nome; });
                    if (selectedSchool) {
                        setValue("nome", selectedSchool.nome);
                        setValue("nome_fantasia", selectedSchool.nome);
                        setValue("inep", selectedSchool.codigo_inep);
                    }
                }, disabled: isFetching || !selectedCity, items: schoolNames === null || schoolNames === void 0 ? void 0 : schoolNames.map(function (school) { return ({
                    label: school.nome,
                    value: school.nome,
                }); }), helperText: message((_c = errors.nome) === null || _c === void 0 ? void 0 : _c.message), variant: ((_d = errors.nome) === null || _d === void 0 ? void 0 : _d.message) ? "critical" : "default" }));
        } }));
}
